//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      user: {},
      visit: {},
      src: '',
      popupVisible: false,
      loading: false,
      ruleForm: {
        diopter_od_sph: '',
        diopter_od_cyl: '',
        diopter_od_axis: '',
        diopter_os_sph: '',
        diopter_os_cyl: '',
        diopter_os_axis: '',
        axis_od: '',
        axis_os: '',
        vision_os: '',
        vision_od: ''
      },
      keys: ['image_vision', 'image_mydriatic', 'image_biometric'],
      images_list: {
        image_vision: [],
        image_mydriatic: [],
        image_biometric: []
      },
      imageTypeMap: {
        image_vision: '含視力結果的病歷',
        image_mydriatic: '散瞳驗光結果',
        image_biometric: '生物測量結果'
      },
      rules: {
        axis_od: [
          { required: true, message: '右眼眼軸不得為空', trigger: 'blur' }
        ],
        axis_os: [
          { required: true, message: '左眼眼軸不得為空', trigger: 'blur' }
        ],
        vision_od: [
          { required: true, message: '右眼視力不得為空', trigger: 'blur' }
        ],
        vision_os: [
          { required: true, message: '左眼視力不得為空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: async function () {
    this.getUser()
    this.getVisit()
  },
  methods: {
    getDate (createdAt) {
      return moment(createdAt).format('YYYY年MM月DD日 HH:mm')
    },
    showImage (src) {
      this.src = src
      this.popupVisible = true
    },
    submitForm () {
      const body = this.ruleForm
      for (let key in body) {
        if (this.rules[key] && this.rules[key][0].required && !body[key]) {
          return Toast({
            message: this.rules[key][0].message,
            duration: 3000
          })
        }
      }
      body.id = this.$route.query.id
      const that = this
      this.loading = true
      this.$store.httpDispatch({})('updateVisit', body).then((res) => {
        const { code, data } = res.data
        this.loading = false
        if (code === 0) {
          return Toast({
            message: '保存成功',
            duration: 3000
          })
        } else {
          return Toast({
            message: '請求失敗',
            duration: 3000
          })
        }
      }).catch((error) => {
        this.loading = false
        return Toast({
          message: '請求失敗',
          duration: 3000
        })
      })
    },
    async getUser () {
      let result = {}
      try {
        result = await this.$store.dispatch('getUser', {
          openid: this.$route.query.openid
        })
      } catch (err) {
        console.log(err)
        return Toast({
          message: '請求失敗',
          duration: 3000
        })
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        console.log(data)
        data.user.provinceCity = `${data.user.province}-${data.user.city}`
        data.user.gender = data.user.sex !== 1 ? '女' : '男'
        this.user = data.user
      }
    },
    async getVisit () {
      let result = {}
      try {
        result = await this.$store.dispatch('getVisit', {
          id: this.$route.query.id
        })
      } catch (err) {
        console.log(err)
        return Toast({
          message: '請求失敗',
          duration: 3000
        })
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        console.log(data)
        this.visit = data.visit
        this.ruleForm.diopter_od_sph = this.visit.diopter_od_sph
        this.ruleForm.diopter_od_cyl = this.visit.diopter_od_cyl
        this.ruleForm.diopter_od_axis = this.visit.diopter_od_axis
        this.ruleForm.diopter_os_sph = this.visit.diopter_os_sph
        this.ruleForm.diopter_os_cyl = this.visit.diopter_os_cyl
        this.ruleForm.diopter_os_axis = this.visit.diopter_os_axis
        this.ruleForm.axis_od = this.visit.axis_od
        this.ruleForm.axis_os = this.visit.axis_os
        this.visit.images.forEach(image => {
          this.images_list[image.type].push(image)
        });
      }
    }
  }
}
